import { Privacy } from "@/components/sections/Privacy";

const PrivacyPage = () => {
  return <Privacy />;
};

export default PrivacyPage;